<div [formGroup]="parentForm">
    <div *ngFor="let field of elements let i = index">
        <ng-container [ngSwitch]="field.type">
            <h3 *ngSwitchCase="'header'">{{ field.label }}</h3>
            <div *ngSwitchDefault>
                <label>{{ field.label }}</label>
                <ng-container [ngSwitch]="field.type">
                    <input *ngSwitchCase="'input'" [formControlName]="field.name || ''" />
                    <textarea *ngSwitchCase="'textarea'" [formControlName]="field.name || ''"></textarea>
                    <input *ngSwitchCase="'checkbox'" type="checkbox" [formControlName]="field.name || ''" />
                    <select *ngSwitchCase="'select'" [formControlName]="field.name || ''">
                        <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
                    </select>
                </ng-container>
            </div>
        </ng-container>

        <div *ngIf="field.children && field.children.length > 0">
            <p><strong>Children:</strong></p>
            <div *ngFor="let child of field.children">
                <app-form-elements [elements]="[child]" [parentForm]="parentForm"></app-form-elements>
            </div>
        </div>
    </div>
</div>